import { render, staticRenderFns } from "./ns-secondary-nav.vue?vue&type=template&id=02b5eb5e&scoped=true&"
import script from "./ns-secondary-nav.vue?vue&type=script&lang=js&"
export * from "./ns-secondary-nav.vue?vue&type=script&lang=js&"
import style0 from "./ns-secondary-nav.vue?vue&type=style&index=0&id=02b5eb5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b5eb5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02b5eb5e')) {
      api.createRecord('02b5eb5e', component.options)
    } else {
      api.reload('02b5eb5e', component.options)
    }
    module.hot.accept("./ns-secondary-nav.vue?vue&type=template&id=02b5eb5e&scoped=true&", function () {
      api.rerender('02b5eb5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/ns-app-elements/src/ns-secondary-nav/ns-secondary-nav.vue"
export default component.exports